/**
 * Paths públicos del storefront bajo host tenant.
 * En subdomain/custom: `/catalogo` (rewrite → `/market/:slug/catalogo`).
 * En host plataforma: `/market/:slug/catalogo`.
 */
import { currentTenantHostSlug } from "@/lib/tenant-host-slug";

function splitPathQueryHash(raw: string): { path: string; rest: string } {
  if (!raw || raw === "/") return { path: "", rest: "" };
  if (raw.startsWith("?") || raw.startsWith("#")) return { path: "", rest: raw };

  const q = raw.indexOf("?");
  const h = raw.indexOf("#");
  let cut = -1;
  if (q >= 0 && h >= 0) cut = Math.min(q, h);
  else if (q >= 0) cut = q;
  else if (h >= 0) cut = h;

  if (cut < 0) return { path: raw, rest: "" };
  return { path: raw.slice(0, cut), rest: raw.slice(cut) };
}

/** Quita `/market/:slug` si el caller pasó la forma interna. */
function stripInternalPrefix(storeSlug: string, raw: string): string {
  const prefix = `/market/${storeSlug}`;
  if (raw === prefix || raw === `${prefix}/`) return "";
  if (raw.startsWith(`${prefix}/`) || raw.startsWith(`${prefix}?`) || raw.startsWith(`${prefix}#`)) {
    return raw.slice(prefix.length);
  }
  return raw;
}

/**
 * Path para `<a href>` / breadcrumbs en el storefront.
 * Acepta sufijo corto (`/catalogo`) o path interno (`/market/:slug/catalogo`).
 */
export function storefrontPath(storeSlug: string, path = ""): string {
  const stripped = stripInternalPrefix(storeSlug, path.trim());
  const { path: pathOnly, rest } = splitPathQueryHash(stripped);
  let normalized = pathOnly;
  if (normalized && !normalized.startsWith("/")) normalized = `/${normalized}`;
  if (normalized.length > 1 && normalized.endsWith("/")) normalized = normalized.slice(0, -1);

  const hostSlug = currentTenantHostSlug();
  if (hostSlug && hostSlug === storeSlug) {
    return `${normalized || "/"}${rest}`;
  }
  return `/market/${storeSlug}${normalized}${rest}`;
}
